import { nanoid } from 'nanoid';

import { useMemo } from 'react';

const useId = () => useMemo(() => nanoid(), []);

export { useId };
